<template>
  <div class="main-toolbar">
    <md-toolbar class="md-black" style="min-height: 200px">
      <div class="md-toolbar-row" style="margin-top: 0px;">
        <div class="md-toolbar-section-start">
          <a v-if="mobilescreen" href="/">
            <img
              src="img/rpas_logo.png"
              style="max-width: 60%;"
              class="center"
            />
          </a>
          <a v-else href="/" style="width: 200px">
            <img
              src="img/rpas_logo.png"
              style="max-width: 80%;"
              class="center"
            />
          </a>
        </div>
      </div>
      <div class="md-toolbar-row" style="margin-top: 0px;">
        <md-divider
          class="md-collapse"
          style="justify-content: flex-start;height: 1px;background-color: white;margin-top: 20px;"
        ></md-divider>
      </div>
      <div class="md-toolbar-row" style="margin-top: 0px;">
        <div class="md-toolbar-section-start">
          <div class="hamburger">
            <drop-down direction="down">
              <md-button
                slot="title"
                class="md-button md-button-link md-simple dropdown-toggle"
                data-toggle="dropdown"
              >
                <i class="material-icons">reorder</i>
              </md-button>
              <ul
                class="dropdown-menu dropdown-with-icons"
                style="font-family: 'Roboto'; color:darkslateblue"
              >
                <li class="md-list-item">
                  <div class="md-list-item-content">
                    <a style="text-transform: none;" href="/">
                      {{ $t("Home") }}
                    </a>
                  </div>
                </li>
                <li class="md-list-item">
                  <div class="md-list-item-content">
                    <a
                      style="text-transform: none;"
                      href="#/pricing"
                    >
                      {{ $t("Pricing") }}
                    </a>
                  </div>
                </li>
                <li class="md-list-item">
                  <div class="md-list-item-content">
                    <a
                      style="text-transform: none;"
                      href="https://www.youtube.com/channel/UC41eWMlFrrF0pcCRhgiYF3Q"
                      target="_blank"
                    >
                      {{ $t("Knowledge") }}
                    </a>
                  </div>
                </li>
                <li class="md-list-item">
                  <div class="md-list-item-content">
                    <a
                      :href="LANDING_BASE_URL + '/contact'"
                      style="text-transform: none;"
                    >
                      {{ $t("Contact") }}
                    </a>
                  </div>
                </li>
                <li class="md-list-item">
                  <div class="md-list-item-content">
                    <a
                      style="text-transform: none;"
                      :href="DASHBOARD_BASE_URL + '#/signup'"
                    >
                      {{ $t("Sign Up") }}
                    </a>
                  </div>
                </li>
                <li class="md-list-item">
                  <div class="md-list-item-content">
                    <a
                      style="text-transform: none;"
                      :href="DASHBOARD_BASE_URL + '#/login'"
                    >
                      {{ $t("Log In") }}
                    </a>
                  </div>
                </li>
              </ul>
            </drop-down>
          </div>
          <div
            class="md-collapse"
            style="justify-content: flex-start;margin-top: -10px;"
          >
            <ul style="display: flex; font: menu;">
              <li class="md-list-item">
                <div class="md-list-item-content">
                  <a style="text-transform: none;" href="/">
                    {{ $t("Home") }}
                  </a>
                </div>
              </li>
              <li class="md-list-item">
                <div class="md-list-item-content">
                  <a
                    style="text-transform: none;"
                    href="#/pricing"
                  >
                    {{ $t("Pricing") }}
                  </a>
                </div>
              </li>
              <li class="md-list-item">
                <div class="md-list-item-content">
                  <a
                    style="text-transform: none;"
                    href="https://www.youtube.com/channel/UC41eWMlFrrF0pcCRhgiYF3Q"
                    target="_blank"
                  >
                    {{ $t("Knowledge") }}
                  </a>
                </div>
              </li>
              <li class="md-list-item">
                <div class="md-list-item-content">
                  <a
                    style="text-transform: none;"
                    :href="LANDING_BASE_URL + '/contact'"
                  >
                    {{ $t("Contact") }}
                  </a>
                </div>
              </li>
              <li class="md-list-item">
                <div class="md-list-item-content">
                  <a
                    style="text-transform: none;"
                    :href="DASHBOARD_BASE_URL + '#/signup'"
                  >
                    {{ $t("Sign Up") }}
                  </a>
                </div>
              </li>
              <li class="md-list-item">
                <div class="md-list-item-content">
                  <a
                    style="text-transform: none;"
                    :href="DASHBOARD_BASE_URL + '#/login'"
                  >
                    {{ $t("Log In") }}
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </md-toolbar>
  </div>
</template>
<script>
import { LANDING_BASE_URL, DASHBOARD_BASE_URL, EventBus } from "@/helpers";
import swal from "sweetalert2";

export default {
  components: {},
  props: {
    logoImg: {
      type: String,
      default: "./img/logo-inverted.png"
    },
    img: {
      type: String,
      default: "./img/default-avatar.png"
    }
  },
  data() {
    return {
      language: "en",
      LANDING_BASE_URL,
      DASHBOARD_BASE_URL
    };
  },
  methods: {
    switchLanguage() {
      var locale = this.language.toLowerCase();
      window.localStorage.setItem("locale", locale);
      this.$root.$i18n.locale = locale;
      this.language = this.language === "FR" ? "EN" : "FR";
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    toggle() {
      this.toggleCard = !this.toggleCard;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 800) {
        this.mobilescreen = true;
      } else {
        this.mobilescreen = false;
      }
    }
  },
  mounted() {
    this.language = window.localStorage.getItem("locale");
    this.onResponsiveInverted();
    window.addEventListener("scroll", this.updateScroll);
    EventBus.$on("signedup", () => {
      this.showSignup = false;
      swal.fire({
        title: this.$t("Thank You"),
        text: this.$t(
          "You successfully signed up. Please check your email to activate your account!"
        ),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("signedup");
  }
};
</script>
<style lang="css">
.main-toolbar {
  position: fixed;
  z-index: 1000;
  left: 0;
  right: 0;
}
.md-toolbar {
  background-color: rgba(0, 0, 0, 0.5);
}
.change_color {
  background-color: white;
}
@media all and (min-width: 991px) {
  .hamburger {
    display: none;
  }
}
@media all and (max-width: 768px) {
  .main-toolbar {
    background-color: white;
  }
}
</style>
